import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { BusinessNameTile } from './BusinessNameTile';
import { BusinessNameTooltip } from './BusinessNameTooltip';
import { BusinessNameTileSkeletons } from './BusinessNameTileSkeleton';
export const BusinessNameTiles = _ref => {
  let names = _ref.names,
    isLoading = _ref.isLoading,
    isFetchingMore = _ref.isFetchingMore,
    namesPerBatch = _ref.namesPerBatch,
    selectedName = _ref.selectedName,
    onSelect = _ref.onSelect,
    onTooltipView = _ref.onTooltipView,
    size = _ref.size,
    nameWeight = _ref.nameWeight,
    showArrowWhenSelected = _ref.showArrowWhenSelected;
  const isMobile = useIsMobile();
  if (isLoading) {
    return /*#__PURE__*/React.createElement(BusinessNameTileSkeletons, {
      count: namesPerBatch,
      keyPrefix: "skeleton",
      size: size
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, names.map((name, idx) => /*#__PURE__*/React.createElement(BusinessNameTile, {
    key: name.id ?? String(idx),
    name: name,
    isSelected: (selectedName == null ? void 0 : selectedName.id) != null && selectedName.id === name.id,
    size: size,
    nameWeight: nameWeight,
    showArrowWhenSelected: showArrowWhenSelected,
    onSelect: onSelect,
    tooltipContent: isMobile ? undefined : /*#__PURE__*/React.createElement(BusinessNameTooltip, {
      name: name
    }),
    onHoverChange: isMobile ? undefined : hovering => {
      if (hovering && name.name) {
        onTooltipView(name.name);
      }
    }
  })), isFetchingMore && /*#__PURE__*/React.createElement(BusinessNameTileSkeletons, {
    count: namesPerBatch,
    keyPrefix: "skeleton-more",
    size: size
  }));
};
//# sourceMappingURL=BusinessNameTiles.js.map